export default __webpack_public_path__ + "static/media/morrisons.46733ee7.svg";